/**
 *  @class
 *  @function ProductTabsV2
 *  Desktop: one panel at a time (tabs). Mobile: each panel toggles on its own (accordions).
 */
if (!customElements.get('product-tabs-v2')) {
  class ProductTabsV2 extends HTMLElement {
    connectedCallback() {
      this.desktop = window.matchMedia('(min-width: 1068px)');
      this.items = Array.from(this.querySelectorAll('.ptv2__item'));
      this.items.forEach((item) => {
        item.querySelector('.ptv2__tab').addEventListener('click', () => this.onClick(item));
      });
      this.desktop.addEventListener('change', () => this.sync());
      this.sync();
    }

    onClick(item) {
      if (this.desktop.matches) {
        this.items.forEach((other) => other.classList.toggle('is-active', other === item));
      } else {
        item.classList.toggle('is-open');
      }
      this.sync();
    }

    sync() {
      this.items.forEach((item) => {
        const expanded = this.desktop.matches ? item.classList.contains('is-active') : item.classList.contains('is-open');
        item.querySelector('.ptv2__tab').setAttribute('aria-expanded', expanded);
      });
    }
  }
  customElements.define('product-tabs-v2', ProductTabsV2);
}
